import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Text } from "../ui/text";
type Option = {
  name: string;
  value: string;
};

type Props = {
  options: Option[];
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  defaultValue?: string;
};

const CustomSelect = ({
  options,
  placeholder,
  defaultValue,
  onChange,
  className,
  disabled,
  ...props
}: Props) => {
  const handleValueChange = (value: string) => {
    let selectedValue: Option | undefined;
    if (typeof options?.[0].value === "object") {
      selectedValue = options.find((option) => option.value.name === value);
    } else {
      selectedValue = options.find((option) => option.value === value);
    }

    onChange?.(selectedValue?.value as string);
  };
  return (
    <Select
      {...props}
      disabled={disabled}
      onValueChange={handleValueChange}
      defaultValue={defaultValue}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} className="" />
      </SelectTrigger>
      <SelectContent className="max-w-[200px]">
       <SelectGroup className="[&_*]:text-[14px]">
          {options?.map((option, index) => (
            <SelectItem
              key={index}
              value={
                typeof option.value === "object"
                  ? option.value.name
                  : option.value
              }
            >
              <Text variant={"title-md"}>{option.name}</Text>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default CustomSelect;
